var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[_c('div',{staticClass:"tab-button close",attrs:{"data-translation-element":"close"},on:{"click":function($event){return _vm.close($event)}}},[_vm._v("Close")]),_c('div',{staticClass:"search-container"},[_c('WFSearch',{ref:"search",attrs:{"limit":10,"showKeyboard":_vm.showKeyboard},on:{"clicked":_vm.onClick}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }